export const MODAL_OPEN  = 'modal:open';
export const MODAL_CLOSE = 'modal:close';


const EVENTS = {
    [MODAL_OPEN]: (modalId) => new CustomEvent(MODAL_OPEN, {
        bubbles: true,
        detail:  {
            modalId,
        },
    }),

    [MODAL_CLOSE]: (modalId) => new CustomEvent(MODAL_CLOSE, {
        bubbles: true,
        detail:  {
            modalId,
        },
    }),
};

/**
 * @param {HTMLElement} target
 * @param {string} eventName
 * @param {...*} args
 * @return {CustomEvent}
 */
export function dispatch(target, eventName, ...args) {
    const event = EVENTS[eventName](...args);

    target.dispatchEvent(event);

    return event;
}
